<template>
    <span v-if="dialog"
        :data-component-name="$options.name"
    >
        <!-- <q-icon 
            @click.stop="showCard = showCard==false"
            v-bind="$attrs"
            name="info"
            round
        ></q-icon> -->
        <button
            @click.stop="showCard = showCard == false"
         >
            <slot>
            </slot>
        </button>
        <q-dialog v-model="showCard">

            <AssignmentsCard
                class="c-project-card__wrap"
                :showCard="showCard"
                @close-dialog="showCard=false"
                :partialsummary="summary"
            />
        </q-dialog>
    </span>
    <AssignmentsCard
        v-else
        class="c-project-card__wrap"
        :showCard="true"
    />
</template>

<script>
    import AssignmentsCard from '@/components/projects/AssignmentsCard.vue'

    export default {
        name: 'AssignmentsCardToggle',
        components: { AssignmentsCard },
        props: {
            dialog: {
                type: Boolean,
                default: true
            },
            summary: {
                type: Object,
                default() { return {} }
            },
        },
        data(){
        	return {
                showCard: false
        	}
        },
        mounted(){
        },
        //computed: {},
        //watch: {},
        methods: {
        },
    }
</script>

<style lang="scss">
    @import "@/scss/components/projects/ProjectCard.scss";
    .q-icon {
        margin-top: 0px;
    }
</style>